import React, { FC, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import { Badge } from '@material-ui/core';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { NotificationProps } from './types';
import { channel1, channel2 } from 'utils/pusherUtills';
const Notification: FC<NotificationProps> = ({ link }) => {
  const classes = useStyles();
  const {
    notificationStore: { openNotification },
    userStore: { getEndUserNotification, endUserNotification, setNewEndUserNotificationUpdate },
  } = useStore();
  const getEndUserNotificationReq = useQuery('getEndUserNotificationReq', () => getEndUserNotification(), {});
  const location = useLocation();
  useEffect(() => {
    function PusherFunction() {
      channel1.bind('end-user-profile-update-request', function (data: any) {
        if (location.pathname !== '/login') {
          setNewEndUserNotificationUpdate(true);
          openNotification('success', data.message);
          getEndUserNotificationReq.refetch();
        }
      });

      channel2.bind('end-user-profile-update-request-count', function (data: any) {
        return data.message;
      });
    }
    PusherFunction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const refetchdata = () => {
    setNewEndUserNotificationUpdate(true);
  };
  return (
    <>
      <div className={classes.notification} onClick={refetchdata}>
        <Link to={link}>
          <Badge badgeContent={endUserNotification?.count} color='primary'>
            <NotificationsNoneIcon color='action' />
          </Badge>
        </Link>
      </div>
    </>
  );
};

export default Notification;
